export enum ContentType {
  SOCIAL_MEDIA = 'SOCIAL_MEDIA',
  PAYMENT = 'PAYMENT',
  CONTACT = 'CONTACT',
  DOCUMENT = 'DOCUMENT',
  BUSINESS = 'BUSINESS'
}
